import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchLoanEmis, clearLoanEmis } from "../redux/slices/LoanEmiSlice";
import { payLoanEmi } from "../redux/slices/PayLoanEmiSlice";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "./ViewLoanEmi.css";
import { current } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const ViewLoanEmi = () => {
  const { loanId } = useParams();
  const { state } = useLocation();
  const loan = state?.loan;
  console.log("loan data is ", loan);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  // const { emis, customerName, loanNumber, count, loading, error } = useSelector(
  //   (state) => state.loanEmi
  // );
  const [customerName, setCustomerName] = useState("");
  const [loanNumber, setLoanNumber] = useState("");
  const [count, setCount] = useState(0);

  const [emis, setEmis] = useState([]);
  const [company, setCompany] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showRevertModal, setShowRevertModal] = useState(false);
  const [selectedEmi, setSelectedEmi] = useState(null);
  const [paymentData, setPaymentData] = useState({
    amountPaid: "",
    paymentMode: "Cash",
    paymentDate: new Date().toISOString().split("T")[0],
  });
  const [revertReason,setRevertReason]=useState("");
  const [submitting, setSubmitting] = useState(false);

  const [previewUrl, setPreviewUrl] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);


  const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;
  const fetchEmis = async () => {
    try {
      const res = await fetch(
        `https://payyug.in/api/group-loan/emi/list?superAdminId=${superAdminId}&grouploanAccountId=${loanId}&page=${currentPage}&limit=${10}`,
      );
      const data = await res.json();
      if (res.ok && data) {
        setEmis(data.data || data || []);
        setCustomerName(data.customerName || "");
        setLoanNumber(data.loanNumber || "");
        setTotalPages(data.pagination.totalPages);
        setCount(
          data.pagination.totalRecords || data.emis?.length || data.length || 0,
        );
      }
    } catch (err) {
      console.error("Failed to fetch emi details", err);
    }
  };
  // Fetch EMI & company data
  useEffect(() => {
    // if (loanId) dispatch(fetchLoanEmis(loanId))

    const fetchCompany = async () => {
      try {
        const res = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${superAdminId}`,
        );
        const data = await res.json();
        if (res.ok && data) {
          if (data.logo)
            data.logoUrl = `https://payyug.in/${data.logo.replace(
              /^images\//,
              "",
            )}`;
          setCompany(data);
        }
      } catch (err) {
        console.error("Failed to fetch company details", err);
      }
    };

    if (superAdminId) fetchCompany();
    fetchEmis();

    return () => {
      dispatch(clearLoanEmis());
    };
  }, [loanId, dispatch, superAdminId, currentPage]);

  const handlePayClick = (emi) => {
    setSelectedEmi(emi);
    setPaymentData({
      amountPaid: emi.emiAmount,
      paymentMode: "Cash",
      paymentDate: new Date().toISOString().split("T")[0],
    });
    setShowModal(true);
  };

  // const handleSubmitPayment = async () => {
  //   if (!selectedEmi) return;
  //   try {
  //     setSubmitting(true);
  //     const resultAction = await dispatch(
  //       payLoanEmi({
  //         loanId,
  //         emiNumber: selectedEmi.emiNumber || selectedEmi.id,
  //         amountPaid: paymentData.amountPaid,
  //         paymentMode: paymentData.paymentMode,
  //         paymentDate: paymentData.paymentDate,
  //       })
  //     );

  //     if (payLoanEmi.fulfilled.match(resultAction)) {
  //       alert(`✅ ${resultAction.payload.message}`);
  //       setShowModal(false);
  //       setSelectedEmi(null);
  //       dispatch(fetchLoanEmis(loanId));
  //     } else {
  //       alert(
  //         "❌ Payment failed: " + (resultAction.payload?.message || "Error")
  //       );
  //     }
  //   } catch (err) {
  //     alert("❌ Payment failed: " + err.message);
  //   } finally {
  //     setSubmitting(false);
  //   }
  // };

  const handleSubmitPayment = async () => {
    if (!selectedEmi) return;

    try {
      setSubmitting(true);

      const payload = {
        emiId: selectedEmi.id,
        paidAmount: paymentData.amountPaid,
        paymentMode: paymentData.paymentMode,
        paidDate: paymentData.paymentDate,
        remark: "nothing",
      };

      const response = await axios.post(
        "https://payyug.in/api/group-loan/emi/pay",
        payload,
      );

      if (response.status === 200 || response.status === 201) {
        toast.success(response?.data?.message||"✅ EMI payment successful!");
        setShowModal(false);
        setSelectedEmi(null);
        setCurrentPage((prev) => prev);
        fetchEmis();
      } else {
        toast.eror("❌ Payment failed. Please try again.");
      }
    } catch (error) {
      console.error("Payment Error:", error);
      toast.error(
        "❌ Payment failed: " +
          (error.response?.data?.message || error.message || "Unknown error"),
      );
    } finally {
      setSubmitting(false);
    }
  };

  const handleRevertClick = (emi) => {
    setSelectedEmi(emi);
    setShowRevertModal(true);
  };

const handleSubmitRevertEmi = async () => {
  if (!selectedEmi) return;

  if ((selectedEmi.status || "").toLowerCase() !== "paid") {
    toast.warn("Only paid EMIs can be reverted.");
    return;
  }

  try {
    setSubmitting(true);
    const response = await axios.post(
      "https://payyug.in/api/group-loan/revert-emi",
      {
        emiId: selectedEmi.id,
        updatedBy: superAdminId,
        reason: revertReason.trim() || "Payment entered by mistake",
      }
    );

    if (response.status === 200 || response.status === 201) {
      toast.success(response.data?.message || "EMI reverted successfully!");
      setShowRevertModal(false);
      setRevertReason("");
      setSelectedEmi(null);
      fetchEmis(); // Refresh EMI list
    } else {
      toast.error("❌ Revert failed. Please try again.");
    }
  } catch (error) {
    console.error("Revert Error:", error);
    toast.error(
      "❌ Revert failed: " +
        (error.response?.data?.message || error.message || "Unknown error")
    );
  } finally {
    setSubmitting(false);
  }
};

  const formatDate = (d) => {
    if (!d) return "-";
    try {
      const dt = typeof d === "string" ? new Date(d) : d;
      return dt.toLocaleDateString("en-GB");
    } catch {
      return d;
    }
  };

  const formatCurrency = (n) => {
    const num = Number(n || 0);
    return `Rs. ${num.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const loadLogoAsDataURL = (src) =>
    new Promise((resolve) => {
      if (!src) return resolve(null);
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          canvas.getContext("2d").drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/png"));
        } catch {
          resolve(null);
        }
      };
      img.onerror = () => resolve(null);
      img.src = src;
    });

  const buildEmiSlipPDF = async (emi, serialNo) => {
    if ((emi.status || "").toLowerCase() !== "paid") {
      toast.warn("Slip is available only for PAID EMIs.");
      return null;
    }

    const doc = new jsPDF({ unit: "pt", format: "a4" });
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 40;

    const logoDataURL = await loadLogoAsDataURL(
      company?.logoUrl || "/techvisionlogo.jpg",
    );

    /* ================= HEADER ================= */
    const headerY = margin;
    if (logoDataURL) {
      doc.addImage(logoDataURL, "PNG", margin, headerY, 60, 60);
    }

    doc.setFont("helvetica", "bold").setFontSize(20);
    doc.text(company?.name || "TechVision Finance", margin + 75, headerY + 25);

    doc.setFont("helvetica", "normal").setFontSize(10);
    doc.text(
      `Email: ${company?.email || "support@techvision.com"}  |  Phone: ${
        company?.phone || "+91 9876543210"
      }`,
      margin + 75,
      headerY + 42,
    );

    doc.setDrawColor(180);
    doc.line(margin, headerY + 70, pageWidth - margin, headerY + 70);

    /* ================= SLIP TITLE ================= */
    doc.setFont("helvetica", "bold").setFontSize(16);
    doc.text("EMI PAYMENT RECEIPT", pageWidth / 2, headerY + 95, {
      align: "center",
    });

    /* ================= META INFO ================= */
    const metaY = headerY + 120;
    const slipNo = `${(loanNumber || "NA").slice(0, 4)}${(
      loanNumber || "NA"
    ).slice(-2)}${emi.installmentNo || serialNo}${(customerName || "X")
      .charAt(0)
      .toUpperCase()}`;

    doc.setFont("helvetica", "bold").setFontSize(11);
    doc.text(`Slip No: ${slipNo}`, margin, metaY);

    doc.setFont("helvetica", "normal");
    doc.text(
      `Generated On: ${formatDate(new Date())}`,
      pageWidth - margin,
      metaY,
      { align: "right" },
    );

    /* ================= CUSTOMER & LOAN DETAILS ================= */
    const sectionY = metaY + 20;
    doc.setFont("helvetica", "bold").setFontSize(13);
    doc.text("Customer & Loan Details", margin, sectionY);

    autoTable(doc, {
      startY: sectionY + 10,
      head: [["Field", "Value"]],
      body: [
        ["Customer Name", String(loan?.memberName || "-")],
        ["Loan Account No", String(loan?.loanAccountNumber || "-")],
        ["EMI No", String(emi?.installmentNo || serialNo)],
        ["Payment Mode", String(emi?.paymentMode || "Cash")],
      ],
      theme: "grid",
      styles: { fontSize: 10, cellPadding: 6 },
      headStyles: { fillColor: [52, 152, 219], textColor: 255 },
      columnStyles: {
        0: { fontStyle: "bold", cellWidth: 160 },
      },
      margin: { left: margin, right: margin },
    });

    /* ================= EMI DETAILS ================= */
    let finalY = doc.lastAutoTable.finalY + 25;
    doc.setFont("helvetica", "bold").setFontSize(13);
    doc.text("EMI Payment Details", margin, finalY);

    autoTable(doc, {
      startY: finalY + 10,
      head: [["Field", "Value"]],
      body: [
        ["EMI Amount", formatCurrency(emi.emiAmount)],
        ["Due Date", formatDate(emi.dueDate)],
        ["Paid Date", formatDate(emi.lastPaidDate)],
        ["Status", emi.status || "-"],
      ],
      theme: "grid",
      styles: { fontSize: 10, cellPadding: 6 },
      headStyles: { fillColor: [46, 204, 113], textColor: 255 },
      columnStyles: {
        0: { fontStyle: "bold", cellWidth: 160 },
      },
      margin: { left: margin, right: margin },
    });

    /* ================= FOOTER ================= */
    const footerY = pageHeight - margin - 40;
    doc.setDrawColor(200);
    doc.line(margin, footerY, pageWidth - margin, footerY);

    doc.setFont("helvetica", "italic").setFontSize(10);
    doc.text(
      `Thank you for your payment. For queries, contact ${
        company?.email || "support@techvision.com"
      }.`,
      margin,
      footerY + 20,
    );

    doc.text(
      `© 2025 ${
        company?.name || "TechVision Finance"
      } Pvt. Ltd. All Rights Reserved.`,
      margin,
      footerY + 35,
    );

    return doc;
  };

  const generateEmiSlipPDF = async (emi, serialNo) => {
    const doc = await buildEmiSlipPDF(emi, serialNo);
    if (!doc) return;
    doc.save(
      `EMI_Slip_${(customerName || "customer").replace(/\W+/g, "_")}_${(
        loanNumber || "loan"
      ).replace(/\W+/g, "_")}_EMI${(emi.installmentNo || serialNo)
        .toString()
        .replace(/\W+/g, "_")}.pdf`,
    );
  };

  const previewEmiSlipPDF = async (emi, serialNo) => {
    const doc = await buildEmiSlipPDF(emi, serialNo);
    if (!doc) return;
    const blob = doc.output("blob");
    const url = URL.createObjectURL(blob);
    setPreviewUrl(url);
    setShowPreview(true);
  };

  /** ==============================
   * NEW: Full EMI Schedule PDF
   * ============================== */
  const generateFullLoanPDF = async () => {
    const doc = new jsPDF({ unit: "pt", format: "a4" });
    const pageWidth = doc.internal.pageSize.getWidth();
    const centerX = pageWidth / 2;
    const margin = 40;
    let y = margin;

    // ---------- HEADER ----------
    const logoDataURL = await loadLogoAsDataURL(
      company?.logoUrl || "/techvisionlogo.jpg",
    );

    if (logoDataURL) {
      // Logo
      doc.addImage(logoDataURL, "PNG", margin, y, 60, 60);

      // Circular border
      doc.setDrawColor(200);
      doc.circle(margin + 30, y + 30, 32);
    }

    // Company Name (Center)
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.text(company?.name || "TechVision Finance", centerX, y + 20, {
      align: "center",
    });

    // Company Details
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);

    if (company?.cin)
      doc.text(`CIN: ${company.cin}`, centerX, y + 36, { align: "center" });

    doc.text(
      `Email: ${company?.email || "support@techvision.com"}`,
      centerX,
      y + 50,
      { align: "center" },
    );

    doc.text(
      `Phone: ${company?.contact || "+91 9876543210"}`,
      centerX,
      y + 64,
      { align: "center" },
    );

    // Divider line
    y += 70;
    doc.setDrawColor(180);
    doc.line(margin, y, pageWidth - margin, y);

    // Title
    y += 18;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text("Loan EMI Schedule", centerX, y, { align: "center" });

    // y += 12;
    // doc.setDrawColor(0);
    // doc.line(margin, y, pageWidth - margin, y);

    // ---------- BODY ----------
    y += 25;
    doc.setFont("helvetica", "bold").setFontSize(12);
    doc.text("Loan & Customer Details", margin, y);

    y += 20;
    doc.setFont("helvetica", "normal").setFontSize(11);
    doc.text(`Customer Name: ${loan?.memberName || "-"}`, margin, y);

    y += 18;
    doc.text(`Loan Account No: ${loan?.loanAccountNumber || "-"}`, margin, y);

    y += 18;
    doc.text(`Total EMIs: ${count || "-"}`, margin, y);

    // ---------- TABLE ----------
    autoTable(doc, {
      startY: y + 25,
      head: [["EMI No", "Due Date", "EMI Amount", "Status", "Payment Date"]],
      body: emis.map((emi, i) => [
        i + 1,
        formatDate(emi.dueDate),
        formatCurrency(emi.emiAmount),
        emi.status || "-",
        emi.lastPaidDate ? formatDate(emi.lastPaidDate) : "-",
      ]),
      theme: "grid",
      styles: { fontSize: 10 },
      headStyles: { fillColor: [16, 144, 191], textColor: 255 },
      margin: { left: margin, right: margin },
    });

    doc.save(
      `Loan_Report_${(customerName || "customer").replace(/\W+/g, "_")}_${(
        loanNumber || "loan"
      ).replace(/\W+/g, "_")}.pdf`,
    );
  };

  // if (loading) return <p>Loading EMI Schedule...</p>;
  // if (error) return <p>Error: {error}</p>;

  return (
    <div className="viewemiloandata-container">
      {/* Header */}
      <header className="viewemiloandata-headerbar">
        <div className="viewemiloandata-company">
          <img
            src={company?.logoUrl || "/techvisionlogo.jpg"}
            alt="Company Logo"
            className="viewemiloandata-logo"
          />
          <div className="view-emi-company-details">
            <h2 className="viewemiloandata-companyname">
              {company?.name || "TechVision Finance"}
            </h2>
            <p>{company?.tagline || "Trusted Loan Partner Since 2010"}</p>
            <p>
              <b>Email:</b> {company?.email || "support@techvision.com"}
            </p>
            <p>
              <b>Phone:</b> {company?.contact || "+91 9876543210"}
            </p>
          </div>
        </div>
      </header>

      {/* Loan Info */}
      <div className="viewemiloandata-loaninfo">
        <h3>Loan & Customer Details</h3>
        <p>
          <strong>Customer Name :</strong> {loan?.memberName}
        </p>
        <p>
          <strong>Loan Account No:</strong> {loan?.loanAccountNumber}
        </p>
        <p>
          <strong>Total EMIs:</strong> {count}
        </p>
      </div>

      {/* EMI Table */}
      <div className="viewemiloandata-table-container">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <h3 className="viewemiloandata-header">Loan EMI Schedule</h3>
        </div>
        {emis.length === 0 ? (
          <p>No EMIs found</p>
        ) : (
          <table className="viewemiloandata-table">
            <thead>
              <tr>
                <th>EMI No</th>
                <th>Due Date</th>
                <th>EMI Amount</th>
                <th>Status</th>
                <th>Payment Date</th>
                <th>Action</th>
                <th>Slip</th>
                <th>Revert EMI</th>
              </tr>
            </thead>
            <tbody>
              {emis.map((emi, index) => {
                const isPaid = (emi.status || "").toLowerCase() === "paid";
                return (
                  <tr key={emi.id}>
                    <td>{(currentPage - 1) * 10 + index + 1}</td>
                    <td>{formatDate(emi.dueDate)}</td>
                    <td>{formatCurrency(emi.emiAmount)}</td>
                    <td style={{ color: isPaid ? "green" : "inherit" }}>
                      {emi.status}
                    </td>
                    <td>
                      {emi.lastPaidDate ? formatDate(emi.lastPaidDate) : "-"}
                    </td>
                    <td>
                      {isPaid ? (
                        <span style={{ color: "green" }}>✔ Paid</span>
                      ) : (
                        <button
                          className="viewemiloandata-btn-pay"
                          onClick={() => handlePayClick(emi)}
                        >
                          Pay
                        </button>
                      )}
                    </td>
                    <td>
                      {isPaid ? (
                        <>
                          <button
                            className="viewemiloandata-btn-print"
                            onClick={() => generateEmiSlipPDF(emi, index + 1)}
                          >
                            Download
                          </button>
                          <button
                            className="viewemiloandata-btn-preview"
                            onClick={() => previewEmiSlipPDF(emi, index + 1)}
                          >
                            Preview
                          </button>
                        </>
                      ) : (
                        <span style={{ color: "gray" }}>
                          Slip after payment
                        </span>
                      )}
                    </td>
                    <td>
                      {isPaid ? (
                        <button
                          className="viewemiloandata-btn-revert"
                          onClick={() => handleRevertClick(emi)}
                        >
                          Revert
                        </button>
                      ) : (
                        <span style={{ color: "gray" }}>-</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      {totalPages > 1 && (
        <div className="LoanReport-pagination">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => prev - 1)}
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((prev) => prev + 1)}
          >
            Next
          </button>
        </div>
      )}

      {/* Actions */}
      <div className="viewemiloandata-actions">
        <button
          className="viewemiloandata-btn-back"
          onClick={() => navigate(-1)}
        >
          Back
        </button>
        <button
          className="viewemiloandata-btn-print"
          onClick={generateFullLoanPDF}
        >
          Download Full PDF
        </button>
      </div>

      {/* Payment Modal */}
      {showModal && (
        <div className="viewemiloandata-modal-overlay">
          <div className="viewemiloandata-modal">
            <h3>Pay EMI (No: {selectedEmi?.installmentNo || selectedEmi?.id})</h3>
            <label>
              Amount Paid:
              <input
                type="number"
                value={paymentData.amountPaid}
                onChange={(e) =>
                  setPaymentData({ ...paymentData, amountPaid: e.target.value })
                }
              />
            </label>
            <label>
              Payment Mode:
              <select
                value={paymentData.paymentMode}
                onChange={(e) =>
                  setPaymentData({
                    ...paymentData,
                    paymentMode: e.target.value,
                  })
                }
              >
                <option value="Cash">Cash</option>
                <option value="Card">Card</option>
                <option value="UPI">UPI</option>
                <option value="NetBanking">Net Banking</option>
              </select>
            </label>
            <label>
              Payment Date:
              <input
                type="date"
                value={paymentData.paymentDate}
                onChange={(e) =>
                  setPaymentData({
                    ...paymentData,
                    paymentDate: e.target.value,
                  })
                }
              />
            </label>
            <div className="modal-actions">
              <button onClick={() => setShowModal(false)}>Cancel</button>
              <button onClick={handleSubmitPayment} disabled={submitting}>
                {submitting ? "Processing..." : "Confirm Pay"}
              </button>
            </div>
          </div>
        </div>
      )}

     {/* Revert Pay Modal */}
{showRevertModal && (
  <div className="viewemiloandata-modal-overlay">
    <div className="viewemiloandata-modal">
      <h3>Revert EMI (No: {selectedEmi?.installmentNo || selectedEmi?.id})</h3>
      <label>
        Reason:
        <input
          type="text"
          value={revertReason}
          placeholder="Enter a valid reason"
          onChange={(e) => setRevertReason(e.target.value)}
        />
      </label>
      <div className="modal-actions">
        <button 
          onClick={() => {
            setShowRevertModal(false);
            setRevertReason("");
          }}
        >
          Cancel
        </button>
        <button onClick={handleSubmitRevertEmi} disabled={submitting}>
          {submitting ? "Processing..." : "Confirm Revert"}
        </button>
      </div>
    </div>
  </div>
)}

      {/* Preview Modal */}
      {showPreview && previewUrl && (
        <div className="viewemiloandata-modal-overlay">
          <div
            className="viewemiloandata-modal"
            style={{ width: "80%", height: "90%" }}
          >
            <h3>Slip Preview</h3>
            <iframe
              src={previewUrl}
              title="Slip Preview"
              style={{ width: "100%", height: "80%", border: "none" }}
            ></iframe>
            <div className="modal-actions">
              <button
                onClick={() => {
                  setShowPreview(false);
                  URL.revokeObjectURL(previewUrl);
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="viewemiloandata-footer">
        <p>
          © 2025 {company?.name || "TechVision Finance"} Pvt. Ltd. All Rights
          Reserved.
        </p>
        <p>
          {company?.tagline || "Empowering Dreams with Smart Loan Solutions"}
        </p>
      </footer>
    </div>
  );
};

export default ViewLoanEmi;
